import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 1rem;
  color: var(--color-yellow);
`;
export const LogoContainer = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 26px;
`;
